import * as actionTypes from "../actions/actionTypes";

const initState = {
  stateDistrictList: [],
  isStateDistrictList: false,

  languagesList: [],
  isLoadinglanguagesList: false,

  recyclingList: [],
  isLoadingRecyclingList: false,

  expressRecyclingList: [],
  isLoadingExpressRecyclingList: false, 
  
  recyclingCategoryList: [],
  isLoadingRecyclingCategoryList: false,

  recyclingExtraFee: [],
  isLoadingRecyclingExtraFee: false,

  recyclingDumpsterList: [],
  isLoadingRecyclingDumpsterList: false,

  dumpsterServiceList: [],
  isLoadingDumpsterServiceList: false,
  
  impartCarbonList: [],
  isLoadingImpartCarbonList: false,

  impartCarbonCert: null,
  isLoadingImpartCarbonCert: false,
  
  generalSetting: null,
  isLoadingGeneralSetting: false,

  charitiesList: [],
  isLoadingCharitiesList: false,
  
  vendingCategoryList: [],
  isLoadingVendingCategoryList: false,

  driverDumpsterList: [],
  isLoadingDriverDumpsterList: false,

  landfillPointList: [],
  isLoadingLandfillPointList: false,

  driverList: [],
  isLoadingDriverList: false,
};

export default function generalReducer(state = initState, action) {
 
  switch (action.type) {
   
    case actionTypes.LOAD_STATE_DISTRICT_LIST: {
      return {
        ...state,
        stateDistrictList: [],
        isStateDistrictList: true,
      };
    }

    case actionTypes.LOAD_STATE_DISTRICT_LIST_SUCCESS: {
      return {
        ...state,
        stateDistrictList: action.data,
        isStateDistrictList: false,

      };
    }

    case actionTypes.LOAD_STATE_DISTRICT_LIST_FAIL: {
      return {
        ...state,
        isStateDistrictList: false,

      };
    }
    
    
    case actionTypes.LOAD_LANGUAGUES: {
      return {
        ...state,
        languagesList: [],
        isLoadinglanguagesList: true,
      };
    }

    case actionTypes.LOAD_LANGUAGUES_SUCCESS: {
      return {
        ...state,
        languagesList: action.data,
        isLoadinglanguagesList: false,

      };
    }

    case actionTypes.LOAD_LANGUAGUES_FAIL: {
      return {
        ...state,
        isLoadinglanguagesList: false,

      };
    }
    
    
    
    case actionTypes.LOAD_EXPRESS_RECYCLING_LIST: {
      return {
        ...state,
        expressRecyclingList: [],
        isLoadingExpressRecyclingList: true,   
      };
    }

    case actionTypes.LOAD_EXPRESS_RECYCLING_LIST_SUCCESS: {

      return {
        ...state,
        expressRecyclingList: action.data,
        isLoadingExpressRecyclingList: false,
      };
    }

    case actionTypes.LOAD_EXPRESS_RECYCLING_LIST_FAIL: {

      return {
        ...state,
      };
    }


    case actionTypes.LOAD_RECYCLING_LIST: {
      return {
        ...state,
        recyclingList: [],
        isLoadingRecyclingList: true,   
      };
    }

    case actionTypes.LOAD_RECYCLING_LIST_SUCCESS: {

      return {
        ...state,
        recyclingList: action.data,
        isLoadingRecyclingList: false,
      };
    }

    case actionTypes.LOAD_RECYCLING_LIST_FAIL: {

      return {
        ...state,
      };
    }

    
    
    
    case actionTypes.LOAD_RECYCLING_CATEGORY: {
      
      return {
        ...state,
        recyclingCategoryList: [],
        isLoadingRecyclingCategoryList: true,
      };
    }

    case actionTypes.LOAD_RECYCLING_CATEGORY_SUCCESS: {
  
      return {
        ...state,
        recyclingCategoryList: action.data,
        isLoadingRecyclingCategoryList: false,
      };
    }

    case actionTypes.LOAD_RECYCLING_CATEGORY_FAIL: {
      return {
        ...state,
        isLoadingRecyclingCategoryList: false,
      };
    }

    
    
    case actionTypes.LOAD_RECYCLING_EXTRA_FEE: {
      
      return {
        ...state,
        recyclingExtraFee: [],
        isLoadingRecyclingExtraFee: true,
      };
    }

    case actionTypes.LOAD_RECYCLING_EXTRA_FEE_SUCCESS: {
  
      return {
        ...state,
        recyclingExtraFee: action.data,
        isLoadingRecyclingExtraFee: false,
      };
    }

    case actionTypes.LOAD_RECYCLING_EXTRA_FEE_FAIL: {
      return {
        ...state,
        isLoadingRecyclingExtraFee: false,
      };
    }
    
    
    case actionTypes.LOAD_RECYCLING_DMPSTER: {
      
      return {
        ...state,
        recyclingDumpsterList: [],
        isLoadingRecyclingDumpsterList: true,
      };
    }

    case actionTypes.LOAD_RECYCLING_DMPSTER_SUCCESS: {
      
      return {
        ...state,
        recyclingDumpsterList: action.data,
        isLoadingRecyclingDumpsterList: false,
      };
    }

    case actionTypes.LOAD_RECYCLING_DMPSTER_FAIL: {
      return {
        ...state,
        isLoadingRecyclingDumpsterList: false,
      };
    }
    
    case actionTypes.LOAD_DMPSTER_SERVICE: {
      
      return {
        ...state,
        dumpsterServiceList: [],
        isLoadingDumpsterServiceList: true,
      };
    }

    case actionTypes.LOAD_DMPSTER_SERVICE_SUCCESS: {
      
      return {
        ...state,
        dumpsterServiceList: action.data,
        isLoadingDumpsterServiceList: false,
      };
    }

    case actionTypes.LOAD_DMPSTER_SERVICE_FAIL: {
      return {
        ...state,
        isLoadingDumpsterServiceList: false,
      };
    }

    
    case actionTypes.LOAD_IMPACT_CARBON: {
      
      return {
        ...state,
        impartCarbonList: [],
        isLoadingImpartCarbonList: true,
      };
    }

    case actionTypes.LOAD_IMPACT_CARBON_SUCCESS: {
      
      return {
        ...state,
        impartCarbonList: action.data,
        isLoadingImpartCarbonList: false,
      };
    }

    case actionTypes.LOAD_IMPACT_CARBON_FAIL: {
      return {
        ...state,
        isLoadingImpartCarbonList: false,
      };
    }

    
    case actionTypes.GET_IMPACT_CARBON_CERT: {
      
      return {
        ...state,
        impartCarbonCert: null,
        isLoadingImpartCarbonCert: true,
      };
    }

    case actionTypes.GET_IMPACT_CARBON_CERT_SUCCESS: {
      
      return {
        ...state,
        impartCarbonCert: action.data,
        isLoadingImpartCarbonCert: false,
      };
    }

    case actionTypes.GET_IMPACT_CARBON_CERT_FAIL: {
      return {
        ...state,
        isLoadingImpartCarbonCert: false,
      };
    }
    
    
    case actionTypes.GET_GENERAL_SETTING: {
      
      return {
        ...state,
        generalSetting: null,
        isLoadingGeneralSetting: true,
      };
    }

    case actionTypes.GET_GENERAL_SETTING_SUCCESS: {
      
      return {
        ...state,
        generalSetting: action.data,
        isLoadingGeneralSetting: false,
      };
    }

    case actionTypes.GET_GENERAL_SETTING_FAIL: {
      return {
        ...state,
        isLoadingGeneralSetting: false,
      };
    }
    
    
    case actionTypes.LOAD_CHARITIES: {
      
      return {
        ...state,
        charitiesList: [],
        isLoadingCharitiesList: true,
      };
    }

    case actionTypes.LOAD_CHARITIES_SUCCESS: {
      
      return {
        ...state,
        charitiesList: action.data,
        isLoadingCharitiesList: false,
      };
    }

    case actionTypes.LOAD_CHARITIES_FAIL: {
      return {
        ...state,
        isLoadingCharitiesList: false,
      };
    }
    
    
    case actionTypes.LOAD_VENDING_CATEGORY: {
      
      return {
        ...state,
        vendingCategoryList: [],
        isLoadingVendingCategoryList: true,
      };
    }

    case actionTypes.LOAD_VENDING_CATEGORY_SUCCESS: {
  
      return {
        ...state,
        vendingCategoryList: action.data,
        isLoadingVendingCategoryList: false,
      };
    }

    case actionTypes.LOAD_VENDING_CATEGORY_FAIL: {
      return {
        ...state,
        isLoadingVendingCategoryList: false,
      };
    }
    
    
    case actionTypes.LOAD_DRIVER_DUMPSTER: {
      
      return {
        ...state,
        driverDumpsterList: [],
        isLoadingDriverDumpsterList: true,
      };
    }

    case actionTypes.LOAD_DRIVER_DUMPSTER_SUCCESS: {
  
      return {
        ...state,
        driverDumpsterList: action.data,
        isLoadingDriverDumpsterList: false,
      };
    }

    case actionTypes.LOAD_DRIVER_DUMPSTER_FAIL: {
      return {
        ...state,
        isLoadingDriverDumpsterList: false,
      };
    }
    
    
    case actionTypes.LOAD_LANDFILL_POINT: {
      
      return {
        ...state,
        landfillPointList: [],
        isLoadingLandfillPointList: true,
      };
    }

    case actionTypes.LOAD_LANDFILL_POINT_SUCCESS: {
  
      return {
        ...state,
        landfillPointList: action.data,
        isLoadingLandfillPointList: false,
      };
    }

    case actionTypes.LOAD_LANDFILL_POINT_FAIL: {
      return {
        ...state,
        isLoadingLandfillPointList: false,
      };
    }
    
    case actionTypes.LOAD_DRIVER_LIST: {
      
      return {
        ...state,
        driverList: [],
        isLoadingDriverList: true,
      };
    }

    case actionTypes.LOAD_DRIVER_LIST_SUCCESS: {
  
      return {
        ...state,
        driverList: action.data,
        isLoadingDriverList: false,
      };
    }

    case actionTypes.LOAD_DRIVER_LIST_FAIL: {
      return {
        ...state,
        isLoadingDriverList: false,
      };
    }

    default:
      return state;
  }
}
